import { Button } from './Button';
import { createSprite } from '../../../utils/GameEngine';
import Rectangle = PIXI.Rectangle;

export class SettingsButtonRound extends Button {
  private cog: PIXI.Sprite;

  constructor(callback?: () => any, scale: number = 1) {
    super('blue_button_round', callback, null, true, true, scale);
  }

  protected drawLayout(): void {
    super.drawLayout();
    this.cog = createSprite('cog', this);
    this.cog.position.set((this.width - this.cog.width) / 2, (this.height - this.cog.height) / 2 - 2);
    this.hitArea = new Rectangle(
        this.defaultSkin.x - this.defaultSkin.width / 2,
        this.defaultSkin.y - this.defaultSkin.height / 2,
        this.defaultSkin.width * 1.5,
        this.defaultSkin.height * 1.5
    );
  }
}